<div class="flex flex-col">
  <div class="flex flex-row text-sm color-primary">
    <span>{{item['vondat'] | format:'DATE.DEFAULT'}} - {{item['bisdat'] | format:'DATE.DEFAULT'}}</span>
  </div>
  <div class="flex flex-row">
    <span class="font-bold">{{item['jahr']}}</span>
  </div>
</div>
